import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { preCalculate } from '../precalc/precalcApi';
import absolut_logo from '../../static/logo/absolut-logo.png'
import zetta_logo from '../../static/logo/zetta-logo.png'
import pari_logo from '../../static/logo/pari-logo.png'
let raitings_p = [1, 2, 3, 4, 5, 6, 7];
let raitings_l = [1, 2, 6, 5, 4, 3];
let min_ind_p = 0
let min_ind_l = 0
let min_premium_property = 1000000000
let min_premium_life = 1000000000
let index_raiting_p = 0
let index_raiting_l = 0
let maxRaitingP = 0
let maxRaitingL = 0
const initialState = {
    typeObject: 'Квартира',
    idBank: '1',
    isManagerCost: false,
    insuranceLogo: '',
    insuranceCompany: 'Абсолют',
    insuranceCompany2: '',
    insuranceCompanyProperty: 'absolute',//zetta, pari, vsk
    insuranceCompanyLife: 'absolute',
    promtCredit: '',
    promt: '',
    promtProperty: '',
    discount: 11,
    isDoubleInsurance: false,


    //new
    listCompaniesProperty: [],
    listCompaniesLife: [],
    indexPropertyMin: 0,
    indexLifeMin: 0,
    indexPropertyPop: 0,
    indexLifePop: 0,
    indexPropertySame: 0,
    indexLifeSame: 0,
    descriptions: {},
    is_empty_res: false,

    //pari
    amount_pari_p: 0,
    amount_pari_l: 0,
    rate_pari_p: 0,
    rate_pari_l: 0,
    tarifs: [],
    isLoadPari: false,
    numPolicyPari: '',
    linkPayPari: '',
    linkPayDom: '',
    linkRedirectPary: '',


    email: '',
    phone: '',
    stepCalc: 'contacts',
    processCalc: 'contacts',
    sumFinalP: 0,
    sumFinalL: 0,
    waitFinalCalc: false,

    idPoliceP: '',
    idPoliceL: '',

    showChangeField: false,

    policyIdProp: 0,
    policyIdLife: 0
};


let arr_companies_property = [];
let arr_companies_life = []

export const clear_arrs = () => {
    min_ind_l = 0
    min_ind_p = 0
    arr_companies_property = []
    arr_companies_life = []
}
// Thunk для 'absolute'
export const fetchAbsoluteData = createAsyncThunk(
    'calc/fetchAbsoluteData',
    async (params, thunkAPI) => {
        return new Promise((resolve, reject) => {
            preCalculate({ ...params, company: 'absolute' }, (data) => {
                console.log('abs', data)
                if (data.premiums.property.length > 0) {
                    const insur_obj = { logo: absolut_logo, company: 'Абсолют', premium: data.premiums.property[0].premium, is_manager: false, xname: 'absolutproperty', insur_comp: 'absolute' }
                    let arr_p = []
                    for (let e of arr_companies_property) {
                        arr_p.push(e)
                    }
                    arr_p.push(insur_obj)
                    arr_companies_property.push(insur_obj)
                    thunkAPI.dispatch(setListCompaniesProperty(arr_p));
                    if (raitings_p[0] > maxRaitingP) {
                        maxRaitingP = raitings_p[0]
                        index_raiting_p = arr_companies_property.length - 1
                    }
                    if (data.premiums.property[0]?.premium) {
                        if (data.premiums.property[0].premium <= arr_companies_property[min_ind_p]?.premium) {
                            min_ind_p = arr_companies_property.length - 1
                            thunkAPI.dispatch(setIndexPropertyMin(min_ind_p))
                            thunkAPI.dispatch(setInsuranceCompanyProperty(arr_companies_property[min_ind_p]?.insur_comp))
                        }
                    }
                }
                if (data.premiums.life.length > 0) {
                    const insur_obj = { logo: absolut_logo, company: 'Абсолют', premium: data.premiums.life[0].premium, is_manager: false, xname: 'absolutlife', insur_comp: 'absolute' }
                    let arr_p = []
                    for (let e of arr_companies_life) {
                        arr_p.push(e)
                    }
                    arr_p.push(insur_obj)
                    arr_companies_life.push(insur_obj)
                    thunkAPI.dispatch(setListCompaniesLife(arr_p));

                    if (raitings_l[0] > maxRaitingL) {
                        maxRaitingL = raitings_l[0]
                        index_raiting_l = arr_companies_life.length - 1
                    }
                    if (data.premiums.life[0]?.premium) {
                        if (data.premiums.life[0].premium <= arr_companies_life[min_ind_l]?.premium) {
                            min_ind_l = arr_companies_life.length - 1
                            thunkAPI.dispatch(setIndexLifeMin(min_ind_l))
                            thunkAPI.dispatch(setInsuranceCompanyLife(arr_companies_life[min_ind_l]?.insur_comp))
                        }
                    }
                }
                resolve(data);
            });
        })
    }
);

// Thunk для 'zetta'
export const fetchZettaData = createAsyncThunk(
    'calc/fetchZettaData',
    async (params, thunkAPI) => {
        return new Promise((resolve, reject) => {
            preCalculate({ ...params, company: 'zetta' }, (data) => {
                console.log('zetta', data)
                if (data.premiums.property.length > 0) {
                    const insur_obj = { logo: zetta_logo, company: 'Зетта', premium: data.premiums.property[0].premium, is_manager: false, xname: 'zettaproperty', insur_comp: 'zetta' }
                    let arr_p = []
                    for (let e of arr_companies_property) {
                        arr_p.push(e)
                    }
                    arr_p.push(insur_obj)
                    arr_companies_property.push(insur_obj)
                    thunkAPI.dispatch(setListCompaniesProperty(arr_p));

                    if (raitings_p[1] > maxRaitingP) {
                        maxRaitingP = raitings_p[1]
                        index_raiting_p = arr_companies_property.length - 1
                    }
                    if (data.premiums.property[0]?.premium) {
                        if (data.premiums.property[0].premium <= arr_companies_property[min_ind_p].premium) {
                            min_ind_p = arr_companies_property.length - 1
                            thunkAPI.dispatch(setIndexPropertyMin(min_ind_p))
                            thunkAPI.dispatch(setInsuranceCompanyProperty(arr_companies_property[min_ind_p]?.insur_comp))
                        }
                    }
                }
                if (data.premiums.life.length > 0) {
                    const insur_obj = { logo: zetta_logo, company: 'Зетта', premium: data.premiums.life[0].premium, is_manager: false, xname: 'zettalife', insur_comp: 'zetta' }
                    let arr_p = []
                    for (let e of arr_companies_life) {
                        arr_p.push(e)
                    }
                    arr_p.push(insur_obj)
                    arr_companies_life.push(insur_obj)
                    thunkAPI.dispatch(setListCompaniesLife(arr_p));

                    if (raitings_l[1] > maxRaitingL) {
                        maxRaitingL = raitings_l[1]
                        index_raiting_l = arr_companies_life.length - 1
                    }
                    if (data.premiums.life[0]?.premium ) {
                        console.log('arr_companies_life', arr_companies_life, min_ind_l)
                        if (data.premiums.life[0].premium <= arr_companies_life[min_ind_l].premium) {
                            min_ind_l = arr_companies_life.length - 1
                            thunkAPI.dispatch(setIndexLifeMin(min_ind_l))
                            thunkAPI.dispatch(setInsuranceCompanyLife(arr_companies_life[min_ind_l]?.insur_comp))
                        }
                    }
                }
                resolve(data);
            });
        })
    }
);


// Thunk для 'pari'
export const fetchPariData = createAsyncThunk(
    'calc/fetchPariData',
    async (params, thunkAPI) => {
        return new Promise((resolve, reject) => {
            preCalculate({ ...params, company: 'pari' }, (data) => {
                console.log('pari', data)
                if (data.premiums.property.length > 0) {
                    const insur_obj = { logo: pari_logo, company: 'ПАРИ', premium: data.premiums.property[0].premium, is_manager: false, xname: 'pariproperty', insur_comp: 'pari' }
                    let arr_p = []
                    for (let e of arr_companies_property) {
                        arr_p.push(e)
                    }
                    arr_p.push(insur_obj)
                    arr_companies_property.push(insur_obj)
                    thunkAPI.dispatch(setListCompaniesProperty(arr_p));

                    if (raitings_p[2] > maxRaitingP) {
                        maxRaitingP = raitings_p[2]
                        index_raiting_p = arr_companies_property.length - 1
                    }
                    if (data.premiums.property[0]?.premium) {
                        console.log('data.premiums.property[0].premium', data.premiums.property[0].premium, arr_companies_property, min_ind_p)
                        if (data.premiums.property[0].premium <= arr_companies_property[min_ind_p]?.premium) {
                            min_ind_p = arr_companies_property.length - 1
                            thunkAPI.dispatch(setIndexPropertyMin(min_ind_p))
                            console.log(arr_companies_property[min_ind_p]?.insur_comp, min_ind_p)
                            thunkAPI.dispatch(setInsuranceCompanyProperty(arr_companies_property[min_ind_p]?.insur_comp))
                        }
                    }

                    thunkAPI.dispatch(setAmountPariP(data.premiums.property[0].amount))
                    thunkAPI.dispatch(setRatePariP(data.premiums.property[0].rate))
                }
                if (data.premiums.life.length > 0) {
                    const insur_obj = { logo: pari_logo, company: 'ПАРИ', premium: data.premiums.life[0].premium, is_manager: false, xname: 'parilife', insur_comp: 'pari' }
                    let arr_p = []
                    for (let e of arr_companies_life) {
                        arr_p.push(e)
                    }
                    arr_p.push(insur_obj)
                    arr_companies_life.push(insur_obj)
                    thunkAPI.dispatch(setListCompaniesLife(arr_p));

                    if (raitings_l[3] > maxRaitingL) {
                        maxRaitingL = raitings_l[3]
                        index_raiting_l = arr_companies_life.length - 1
                    }
                    if (data.premiums.life[0]?.premium) {
                        if (data.premiums.life[0].premium <= arr_companies_life[min_ind_l]?.premium) {
                            min_ind_l = arr_companies_property.length - 1
                            thunkAPI.dispatch(setIndexPropertyMin(min_ind_l))
                            thunkAPI.dispatch(setInsuranceCompanyLife(arr_companies_property[min_ind_l]?.insur_comp))
                        }
                    }
                    thunkAPI.dispatch(setAmountPariL(data.premiums.life[0].amount))
                    thunkAPI.dispatch(setRatePariL(data.premiums.life[0].rate))
                }
                resolve(data);

            });
        })
    }
);


export const calcSlice = createSlice({
    name: 'calc',
    initialState,
    reducers: {
        setPolicyIdProp: (state, action) => {
            state.policyIdProp = action.payload
        },
        setPolicyIdLife: (state, action) => {
            state.policyIdLife = action.payload
        },
        setLinkRedirectPary: (state, action) => {
            state.linkRedirectPary = action.payload
        },
        setShowChangeField: (state, action) => {
            state.showChangeField = action.payload
        },
        setPhone: (state, action) => {
            state.phone = action.payload
        },
        setIdPoliceL: (state, action) => {
            state.idPoliceL = action.payload
        },
        setIdPoliceP: (state, action) => {
            state.idPoliceP = action.payload
        },
        setNumPolicyPari: (state, action) => {
            state.numPolicyPari = action.payload
        },
        setLinkPayPari: (state, action) => {
            state.linkPayPari = action.payload
        },
        setLinkPayDom: (state, action) => {
            state.linkPayDom = action.payload
        },
        setIsLoadPari: (state, action) => {
            state.isLoadPari = action.payload
        },
        setWaitFinalCalc: (state, action) => {
            state.waitFinalCalc = action.payload
        },
        setSumFinalP: (state, action) => {
            state.sumFinalP = action.payload
        },
        setSumFinalL: (state, action) => {
            state.sumFinalL = action.payload
        },
        setInsuranceCompanyProperty: (state, action) => {
            state.insuranceCompanyProperty = action.payload
        },
        setInsuranceCompanyLife: (state, action) => {
            state.insuranceCompanyLife = action.payload
        },
        setStepCalc: (state, action) => {
            state.stepCalc = action.payload
        },
        setProcessCalc: (state, action) => {
            state.processCalc = action.payload
        },
        setEmail: (state, action) => {
            state.email = action.payload
        },
        setTarifs: (state, action) => {
            state.tarifs = action.payload
        },
        setRatePariP: (state, action) => {
            state.rate_pari_p = action.payload
        },
        setRatePariL: (state, action) => {
            state.rate_pari_l = action.payload
        },
        setAmountPariP: (state, action) => {
            state.amount_pari_p = action.payload
        },
        setAmountPariL: (state, action) => {
            state.amount_pari_l = action.payload
        },
        setIsEmptyRes: (state, action) => {
            state.is_empty_res = action.payload
        },

        setDescriptions: (state, action) => {
            state.descriptions = action.payload
        },

        setIndexLifeSame: (state, action) => {
            state.indexLifeSame = action.payload
        },

        setIndexPropertySame: (state, action) => {
            state.indexPropertySame = action.payload
        },

        setIndexLifePop: (state, action) => {
            state.indexLifePop = action.payload
        },

        setIndexPropertyPop: (state, action) => {
            state.indexPropertyPop = action.payload
        },

        setIndexLifeMin: (state, action) => {
            state.indexLifeMin = action.payload
        },

        setIndexPropertyMin: (state, action) => {
            state.indexPropertyMin = action.payload
        },

        setListCompaniesLife: (state, action) => {
            state.listCompaniesLife = action.payload
        },

        setListCompaniesProperty: (state, action) => {
            state.listCompaniesProperty = action.payload
        },

        setDiscount: (state, action) => {
            state.discount = action.payload
        },

        setPromtProperty: (state, action) => {
            state.promtProperty = action.payload
        },

        setPromt: (state, action) => {
            state.promt = action.payload
        },

        setPromtCredit: (state, action) => {
            state.promtCredit = action.payload
        },

        setTypeObject: (state, action) => {
            state.typeObject = action.payload
        },

        setIdBank: (state, action) => {
            state.idBank = action.payload
        },

        setIsManagerCost: (state, action) => {
            state.isManagerCost = action.payload
        },

        setInsuranceLogo: (state, action) => {
            state.insuranceLogo = action.payload
        },

        setInsuranceCompany: (state, action) => {
            state.insuranceCompany = action.payload
        },

        setInsuranceCompany2: (state, action) => {
            state.insuranceCompany2 = action.payload
        },

        setIsDoubleInsurance: (state, action) => {
            state.isDoubleInsurance = action.payload
        },

    },
    extraReducers: (builder) => {
        // Обработка результата для 'absolute'
        builder.addCase(fetchAbsoluteData.fulfilled, (state, action) => {
            const data = action.payload;
            // Ваш код обработки ответа для 'absolute'
            // Пример: arr_companies_property.push(...);
            // dispatch(setListCompaniesProperty(arr_companies_property));
        });

        // Обработка результата для 'zetta'
        builder.addCase(fetchZettaData.fulfilled, (state, action) => {
            const data = action.payload;
            // Ваш код обработки ответа для 'zetta'
            // Пример: arr_companies_property.push(...);
            // dispatch(setListCompaniesProperty(arr_companies_property));
        });

        // ... Другие обработчики ...

    },
});

export const {
    setProcessCalc,
    setLinkRedirectPary,
    setShowChangeField,
    setPhone,
    setLinkPayDom,
    setIdPoliceP,
    setIdPoliceL,
    setLinkPayPari,
    setNumPolicyPari,
    setIsLoadPari,
    setWaitFinalCalc,
    setSumFinalP,
    setSumFinalL,
    setInsuranceCompanyLife,
    setInsuranceCompanyProperty,
    setStepCalc,
    setEmail,
    setTarifs,
    setRatePariL,
    setRatePariP,
    setAmountPariL,
    setAmountPariP,
    setIsEmptyRes,
    setDescriptions,
    setIndexLifeSame,
    setIndexPropertySame,
    setIndexLifePop,
    setIndexPropertyPop,
    setIsDoubleInsurance,
    setTypeObject,
    setIdBank,
    setIsManagerCost,
    setInsuranceLogo,
    setInsuranceCompany,
    setInsuranceCompany2,
    setPromtCredit,
    setPromt,
    setPromtProperty,
    setDiscount,
    setListCompaniesLife,
    setListCompaniesProperty,
    setIndexLifeMin,
    setIndexPropertyMin,
    setPolicyIdProp,
    setPolicyIdLife
} = calcSlice.actions;

export const selectPolicyIdProp = (state) => state.calc.policyIdProp;
export const selectPolicyIdLife = (state) => state.calc.policyIdLife;
export const selectShowChangeField = (state) => state.calc.showChangeField;
export const selectPhone = (state) => state.calc.phone;
export const selectIdPoliceP = (state) => state.calc.idPoliceP;
export const selectIdPoliceL = (state) => state.calc.idPoliceL;
export const selectLinkPayPari = (state) => state.calc.linkPayPari;
export const selectLinkPayDom = (state) => state.calc.linkPayDom;
export const selectNumPolicyPari = (state) => state.calc.numPolicyPari;
export const selectIsLoadPari = (state) => state.calc.isLoadPari;
export const selectWaitFinalCalc = (state) => state.calc.waitFinalCalc;
export const selectStepCalc = (state) => state.calc.stepCalc;
export const selectProcessCalc = (state) => state.calc.processCalc;
export const selectEmail = (state) => state.calc.email;
export const selectTypeObject = (state) => state.calc.typeObject;
export const selectIdBank = (state) => state.calc.idBank;
export const selectIsManagerCost = (state) => state.calc.isManagerCost;
export const selectInsuranceLogo = (state) => state.calc.insuranceLogo;
export const selectInsuranceCompany = (state) => state.calc.insuranceCompany;
export const selectInsuranceCompany2 = (state) => state.calc.insuranceCompany2;
export const selectInsuranceCompanyProperty = (state) => state.calc.insuranceCompanyProperty;
export const selectInsuranceCompanyLife = (state) => state.calc.insuranceCompanyLife;

export const selectPromtCredit = (state) => state.calc.promtCredit;
export const selectPromt = (state) => state.calc.promt;
export const selectPromtProperty = (state) => state.calc.promtProperty;
export const selectDiscount = (state) => state.calc.discount;
export const selectIsDoubleInsurance = (state) => state.calc.isDoubleInsurance;


export const selectListCompaniesLife = (state) => state.calc.listCompaniesLife;
export const selectListCompaniesProperty = (state) => state.calc.listCompaniesProperty;
export const selectIndexLifeMin = (state) => state.calc.indexLifeMin;
export const selectIndexPropertyMin = (state) => state.calc.indexPropertyMin;
export const selectIndexLifePop = (state) => state.calc.indexLifePop;
export const selectIndexPropertyPop = (state) => state.calc.indexPropertyPop;
export const selectIndexLifeSame = (state) => state.calc.indexLifeSame;
export const selectIndexPropertySame = (state) => state.calc.indexPropertySame;
export const selectDescriptions = (state) => state.calc.descriptions;
export const selectIsEmptyRes = (state) => state.calc.is_empty_res;

export const selectAmountPariP = (state) => state.calc.amount_pari_p;
export const selectAmountPariL = (state) => state.calc.amount_pari_l;

export const selectRatePariL = (state) => state.calc.rate_pari_l;
export const selectRatePariP = (state) => state.calc.rate_pari_p;

export const selectTarifs = (state) => state.calc.tarifs;

export const selectSumFinalP = (state) => state.calc.sumFinalP;
export const selectSumFinalL = (state) => state.calc.sumFinalL;
export const selectLinkRedirectPary = (state) => state.calc.linkRedirectPary;


export default calcSlice.reducer;
